import React from 'react';

const LearnMore = () => {
  return (
    <div className="bg-white py-10 px-6 text-gray-900">
      <div className="max-w-5xl mx-auto">
        {/* Introduction */}
        <h1 className="text-4xl font-bold mb-6 text-indigo-700">
          What is uCart?
        </h1>
        <p className="text-lg mb-4">
          <strong>uCart</strong> is a rebranded and upgraded version of <strong>iBuyUNN</strong> — a digital marketplace originally built for students of the University of Nigeria, Nsukka (UNN), and now expanding to campuses across Nigeria. 
        </p>
        <p className="text-lg mb-4">
          Think of it as a <strong>student-focused Jumia</strong> — designed to make campus buying, selling, and renting seamless. You can list products for sale, browse items, place orders, and pick them up easily within your school environment.  
          Plus, it includes <strong>CampusKeys</strong>, our verified housing platform connecting students to trusted lodge spaces and roommates.
        </p>

        {/* How it Works */}
        <h2 className="text-2xl font-semibold mt-8 mb-3 text-indigo-600">
          How Selling Works
        </h2>
        <ol className="list-decimal list-inside text-lg space-y-2 mb-6">
          <li>
            <strong>Register:</strong> Create an account using your email or student ID.
          </li>
          <li>
            <strong>Create your seller profile:</strong> Fill in details like your name, phone, and whether you’re a buyer or seller. 
          </li>
          <li>
            <strong>Upload products:</strong> Click “Add Product”, upload clear photos, add a name, description, and price.
          </li>
          <li>
            <strong>Order process:</strong> Buyers place orders directly through uCart. You’ll be notified and can set a pickup point (e.g., hostel area, department, or park).
          </li>
          <li>
            <strong>Payment:</strong> Buyers pay securely through the platform. uCart holds the funds until the order is confirmed as received.
          </li>
        </ol>

        {/* CampusKeys */}
        <div className="mt-10">
          <h2 className="text-2xl font-semibold text-purple-700 mb-3">What is CampusKeys?</h2>
          <p className="text-lg mb-3">
            <strong>CampusKeys</strong> is uCart’s verified student housing service. Whether you’re looking for a lodge, hostel room, or short-term student accommodation, CampusKeys connects you to safe and verified listings within and around your campus.
          </p>
          <p className="text-lg mb-4">
            Filter by location, price range, amenities (like water, Wi-Fi, or light), and room type (single, self-con, shared, etc.). Each listing includes images, pricing, and contact details for easy viewing or booking.
          </p>
          <ul className="list-disc ml-6 text-lg space-y-2">
            <li>Post your lodge space when relocating or graduating</li>
            <li>Find verified and affordable student accommodation easily</li>
            <li>Zero agent fees — connect directly with landlords or verified student reps</li>
          </ul>
        </div>

        {/* Platform Benefits */}
        <div className="mt-10">
          <h3 className="text-xl font-bold mb-3 text-green-600">
            Why Use uCart?
          </h3>
          <ul className="list-disc ml-6 text-lg space-y-2">
            <li>Built for university students across Nigeria</li>
            <li>Safe and simple — pickup or meet within campus</li>
            <li>Verified sellers and product listings</li>
            <li>All payments are secured until confirmation</li>
            <li>Includes trusted housing listings through CampusKeys</li>
          </ul>
        </div>

        {/* Safety */}
        <div className="mt-10">
          <h3 className="text-xl font-bold mb-3 text-red-600">Is uCart Safe?</h3>
          <p className="text-lg mb-4">
            Yes, safety is our top priority. Every user must register before buying or selling. Payments are only released to sellers after buyers confirm receipt. 
            Sellers are verified, and listings are reviewed to prevent scams. For housing, CampusKeys verifies all posted lodges and monitors suspicious activity.
          </p>
        </div>

        {/* FAQs */}
        <div className="mt-10">
          <h3 className="text-xl font-bold mb-3 text-blue-600">Frequently Asked Questions (FAQs)</h3>
          <div className="space-y-4 text-lg">
            <div>
              <h4 className="font-semibold">Q: How do I get my order?</h4>
              <p>A: After placing an order, you’ll get notified on your Email with a pickup location on your campus (e.g., hostel area, faculty park, or any agreed point).</p>
            </div>
            <div>
              <h4 className="font-semibold">Q: Can I pay on delivery?</h4>
              <p>A: Not yet. Payments are made online for security. Funds are held by uCart until you confirm receipt of your order.</p>
            </div>
            <div>
              <h4 className="font-semibold">Q: How do I list a lodge or room?</h4>
              <p>A: Go to the CampusKeys section, click “Add Lodge/Room”, fill in all the details, upload clear photos, and submit for verification.</p>
            </div>
            <div>
              <h4 className="font-semibold">Q: Is pickup the only delivery option?</h4>
              <p>A: For now, yes. But full delivery and nationwide shipping are coming soon as we expand across more schools.</p>
            </div>
          </div>
        </div>

        {/* Final CTA */}
        <div className="mt-12 text-center">
          <h2 className="text-2xl font-semibold text-indigo-700">Join the uCart Revolution</h2>
          <p className="text-lg mt-2">
            Be part of the next generation student marketplace. Buy, sell, or rent anything — from gadgets to lodges — all within your school community.  
            uCart is more than a marketplace; it’s a movement connecting campuses across Nigeria.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LearnMore;
